import { apiSlice } from './apiSlice'

/**
 * Quality › Sampling Data — "Edit PS Result" bulk edit endpoints.
 * Converted from Access `frmQualityQrySampling_EditManyResult_Add`.
 *
 * BE: app/api/v1/endpoints/quality_sampling_edit_ps.py
 *   GET  /quality-samplings/edit-ps-result?tlcContractRef=...  -> rows for the grid
 *   PUT  /quality-samplings/edit-ps-result                     -> batch update ticked rows
 *
 * Web deviation vs Access: no global tmp_quality_sampling temp table — GET queries
 * view_factory_sampling3 directly filtered by the contract ref (race-safe for many users).
 */

/** One 'In Use' sample row (mirrors BE SamplingEditPsRow). */
export interface SamplingEditPsRow {
  id: number
  sampleNo: string | null
  tlcContractRef: string | null
  lotId: string | null
  clientLotId: string | null
  grade: string | null
  consignee: string | null
  // Editable
  resultReceiptDate: string | null
  result: string | null
  rejectReason: string | null
  clientSampleRef: string | null
}

export interface SamplingEditPsListResponse {
  rows: SamplingEditPsRow[]
}

export interface SamplingEditPsUpdateItem {
  id: number
  resultReceiptDate?: string | null
  result?: string | null
  rejectReason?: string | null
  clientSampleRef?: string | null
}

export interface SamplingEditPsUpdateRequest {
  rows: SamplingEditPsUpdateItem[]
}

export interface SamplingEditPsUpdateResponse {
  updated: number
}

const BASE = '/quality-samplings/edit-ps-result'

const samplingEditPsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSamplingsForEditPs: builder.query<SamplingEditPsListResponse, string>({
      query: (tlcContractRef) => ({ url: BASE, params: { tlcContractRef } }),
      // Reuse the shared QualitySampling tag (registered in apiSlice.ts).
      providesTags: ['QualitySampling'],
    }),

    updateSamplingsPsResult: builder.mutation<SamplingEditPsUpdateResponse, SamplingEditPsUpdateRequest>({
      query: (body) => ({ url: BASE, method: 'PUT', body }),
      invalidatesTags: ['QualitySampling'],
    }),
  }),
})

export const {
  useGetSamplingsForEditPsQuery,
  useUpdateSamplingsPsResultMutation,
} = samplingEditPsApi

export default samplingEditPsApi
